import { render, staticRenderFns } from "./icon-trash-can.component.vue?vue&type=template&id=8e1927f6&scoped=true&"
import script from "./icon-trash-can.component.vue?vue&type=script&lang=ts&"
export * from "./icon-trash-can.component.vue?vue&type=script&lang=ts&"
import style0 from "./icon-trash-can.component.vue?vue&type=style&index=0&id=8e1927f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1927f6",
  null
  
)

export default component.exports